import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import moment from "moment";
import Link from "components/ExtendLink";
import Avatar from "react-avatar";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Card,
  Button,
  CardTitle,
  CardText,
  CardBody,
  CardFooter,
  CardHeader,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  CustomInput
} from "reactstrap";
import StaffDetails from "../../Staff/StaffDetails";
const _ = require("lodash");
function fullname(cell, row) {
  return (
    <div className={row.user && row.user.isActive ? "" : " text-danger"}>
      <span>
        <img
          src="https://cdn-icons-png.flaticon.com/512/194/194915.png"
          className="mr-2"
          alt="image"
        />
        {capitalize(row.lname)} {capitalize(row.fname)}
      </span>
    </div>
  );
}
function capitalize(cell) {
  if (cell) {
    return cell.charAt(0).toUpperCase() + cell.slice(1);
  }
}
function isApproved(cell, row) {
  return (
    <span>
      {cell ? (
        <label className="badge badge-gradient-success">ACCOUNT CREATED</label>
      ) : (
        <label className="badge badge-warning">PENDING INVITATION</label>
      )}
    </span>
  );
}
function formatDate(cell, row) {
  return moment(row.receivedBy.bday).format("MMMM DD, YYYY");
}
function priceFormatter(column, colIndex, { sortElement, filterElement }) {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <span className="mb-2">{filterElement}</span>

      {column.text}
      {sortElement}
    </div>
  );
}
function showButtons(cell, row, rowIndex, formatExtraData) {
  return (
    <div>
      {!row.isCreated && (
        <button
          type="button"
          onClick={() => formatExtraData.delete(row._id)}
          className="btn btn-danger btn-fw"
        >
          Delete Invitation
        </button>
      )}
    </div>
  );
}
const rowComponent = (
  row,
  users,
  expectations,
  userInputChange,
  expectationInputChange
) => {
  return (
    <div>Under Maintenance</div>
    // <StaffDetails
    //   row={row}
    //   users={users}
    //   userInputChange={userInputChange}
    //   expectationInputChange={expectationInputChange}
    //   expectations={expectations}
    // />
  );
};
const StaffList = (props, context) => (
  <div className="scrollbar-table-cls">
  <BootstrapTable
    wrapperClasses="table-responsive"
    keyField="_id"
    noDataIndication="No Data Found"
    data={props.staff}
    expandRow={{
      renderer: row =>
        rowComponent(
          row,
          props.usersOfferedAccess,
          props.expectations,
          props.userInputChange,
          props.expectationInputChange
        ),

      showExpandColumn: true
    }}
    filter={filterFactory()}
    columns={[
      {
        dataField: "fname",
        text: "Name",
        formatter: fullname,
        sort: true,
        filter: textFilter(),
        filterValue: (cell, row) => {
          return row.fname + " " + row.lname;
        },
        headerFormatter: priceFormatter
      },
      {
        dataField: "user.nickname",
        text: "Nickname",
        sort: true,
        formatter: (cell, row) => {
          return (row.user.nickname? row.user.nickname :"-");
        },
        filter: textFilter(),
        filterValue: (cell, row) => {
          return (row.user.nickname? row.user.nickname :"-");
        },
        headerFormatter: priceFormatter,          
      },
      {
        dataField: "email",
        text: "Email",
        sort: true,
        filter: textFilter(),
        headerFormatter: priceFormatter
      },
      {
        dataField: "role",
        text: "Role",
        sort: true,
        filter: textFilter(),
        formatter: capitalize,
        headerFormatter: priceFormatter
      },

      {
        dataField: "isCreated",
        text: "Status",
        formatter: isApproved,
        headerFormatter: priceFormatter
      },
      {
        dataField: "action",
        text: "Action",
        formatter: showButtons,
        headerFormatter: priceFormatter,
        formatExtraData: {
          delete: props.deleteInvitation
        }
      }
    ]}
  />
  </div>
);

export default StaffList;
